import React from 'react'
import { Container } from 'semantic-ui-react'

export default function NotFoundPage() {
  return <Container textAlign="center">Not Found page</Container>
}
